"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Placeholder = _interopRequireDefault(require("./Placeholder"));

exports.default = _Placeholder.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/elements/Placeholder/index.js
// module id = 1473
// module chunks = 0